import { get } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

const { APIS } = API_ENDPOINTS;

// eslint-disable-next-line import/prefer-default-export
export const getAllPricebooksService = () =>
  new Promise((resolve, reject) => {
    get(APIS.PRICE_LISTS)
      .then(res => {
        resolve(res.PriceListPage.plists);
      })
      .catch(err => {
        reject(err);
      });
  });
